module.exports = __webpack_public_path__ + "img/tc.c61ef06.svg";